const Loader = ({ message = "Loading..." }) => (
  <div
    style={{ display: "flex", flexDirection: "column", alignItems: "center" }}
  >
    <div
      style={{
        width: "50px",
        height: "50px",
        border: "5px solid #ddd",
        borderTop: "5px solid #8ec5fc",
        borderRadius: "50%",
        animation: "spin 1s linear infinite",
      }}
    ></div>
    <p style={{ marginTop: "20px", fontSize: "100%", color: "#489ff6" }}>
      {message}
    </p>
    <style>
      {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
    </style>
  </div>
);

export default Loader;
